// Scales the wordcloud so all words together fill the space between title and footer.
// Item sizes are em-based (see _slideshow.scss), so only the container's font-size is searched.

const WORDS_SELECTOR = '.js-wordcloud-words';
const FOOTER_SELECTOR = '.c-slideshow__footer';
const MIN_FONT_SIZE = 8;
// Fallback when --menti-max-font-size is not set in _slideshow.scss.
const DEFAULT_MAX_FONT_SIZE = 64;

function fits(words: HTMLElement, availableHeight: number): boolean {
	return (
		words.scrollHeight <= availableHeight &&
		words.scrollWidth <= words.clientWidth
	);
}

function fit(): void {
	const words = document.querySelector(WORDS_SELECTOR) as HTMLElement | null;
	if (words == null || words.children.length === 0) {
		return;
	}

	const footer = document.querySelector(FOOTER_SELECTOR) as HTMLElement | null;
	const top = words.getBoundingClientRect().top + window.scrollY;
	const bottom = window.innerHeight - (footer?.offsetHeight ?? 0);
	// scrollHeight is an integer, so round down or a fractional top never fits.
	const availableHeight = Math.max(Math.floor(bottom - top), 0);

	words.style.height = `${availableHeight}px`;

	const maxFontSize =
		parseFloat(getComputedStyle(words).getPropertyValue('--menti-max-font-size')) ||
		DEFAULT_MAX_FONT_SIZE;

	// Few words would otherwise grow to poster size - start at the cap and only shrink.
	words.style.fontSize = `${maxFontSize}px`;
	if (fits(words, availableHeight)) {
		return;
	}

	let low = MIN_FONT_SIZE;
	let high = maxFontSize;
	while (high - low > 0.5) {
		const mid = (low + high) / 2;
		words.style.fontSize = `${mid}px`;
		if (fits(words, availableHeight)) {
			low = mid;
		} else {
			high = mid;
		}
	}

	words.style.fontSize = `${low}px`;
}

let resizeListenerAdded = false;

window.wordcloudFit = () => {
	if (!resizeListenerAdded) {
		window.addEventListener('resize', fit);
		resizeListenerAdded = true;
	}

	fit();
	// Web fonts change glyph widths - refit once they are loaded.
	document.fonts?.ready.then(fit);
};
